export default {"src":"/_next/static/media/schedule-appo.0181c5fa.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};